import { getConsentMode, subscribeConsentMode } from '../services/consentMode';
import type { AnalyticsEvent } from './types';

// A full -> private -> full round trip must never revive previously queued exports.
let consentGeneration = 0;
subscribeConsentMode(() => {
    consentGeneration += 1;
});

export function getAnalyticsConsentGeneration(): number {
    return consentGeneration;
}

export function canExportAnalytics(event?: AnalyticsEvent): boolean {
    return (
        getConsentMode() === 'full' &&
        (!event ||
            ((event.consentMode === undefined || event.consentMode === 'full') &&
                (event.consentGeneration === undefined ||
                    event.consentGeneration === consentGeneration)))
    );
}
